module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon5.82874f8906b31746670efa76b051efb1.png";